import { constants } from "@newsela/angelou";

export const buttonCss = {
  root: {
    width: "100%",
    height: 48,
    backgroundColor: constants.colors.ui.white[50],
    padding: "4px 28px 4px 8px",
    borderRadius: 4,
    textDecoration: "none",
    color: constants.colors.ui.neutral[500],
    whiteSpace: "nowrap",
    boxShadow:
      "0px 1px 1px 0px rgba(0, 0, 0, 0.17), 0px 0px 1px 0px rgba(0, 0, 0, 0.08)",
    div: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      textAlign: "left",
    },
    span: {
      width: "100%",
      marginLeft: 8,
    },
  },
  Icon: {
    root: {
      width: "100%",
      maxWidth: 40,
      minWidth: 40,
      margin: 0,
    },
  },
};
